type FormWithWelcomeScreen = {
  welcomeScreen?: {
    enabled?: unknown
  }
}

export function isWelcomeScreenEnabled(form: FormWithWelcomeScreen) {
  return form.welcomeScreen?.enabled === true
}
